import { render, staticRenderFns } from "./SCard.vue?vue&type=template&id=070d8b77&"
import script from "./SCard.vue?vue&type=script&lang=js&"
export * from "./SCard.vue?vue&type=script&lang=js&"
import style0 from "./SCard.vue?vue&type=style&index=0&id=070d8b77&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports